import api from './api';

export const userService = {
  // Get all users (owner) — supports ?user_type=&is_active=
  getAllUsers: async (params = {}) => {
    return await api.get('/users', { params });
  },

  // Get user by ID (owner)
  getUserById: async (userId) => {
    return await api.get(`/users/${userId}`);
  },

  // Update any user (owner) or own profile (customer via /users/me)
  updateUser: async (userId, userData) => {
    return await api.put(`/users/${userId}`, userData);
  },

  // Update own profile (customer)
  updateMyProfile: async (userData) => {
    return await api.put('/users/me', userData);
  },

  // Soft-deactivate user (owner)
  deactivateUser: async (userId) => {
    return await api.delete(`/users/${userId}`);
  },

  // All customers list for agent booking dropdown
  getAllCustomers: async () => {
    return await api.get('/users/customers/list');
  },

  // Customers this agent has booked for
  getMyCustomers: async () => {
    return await api.get('/users/agent/customers');
  },

  // All agents (owner) with commission_rate
  getAgents: async () => {
    return await api.get('/users', { params: { user_type: 'agent' } });
  },

  // Create a new agent account (owner)
  createAgent: async (data) => {
    return await api.post('/users/agents', data);
  },

  // Update agent's commission rate (owner)
  updateAgentCommission: async (agentId, commission_rate) => {
    return await api.put(`/users/agents/${agentId}/commission`, { commission_rate });
  },
};